var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLightingbulb = function SvgLightingbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.796 4.89c3.145 3.114 4.877 7.243 4.877 11.627 0 4.756-2.092 9.283-5.74 12.421-2.446 2.104-4.171 4.915-4.99 8.13l-.488 1.911H20.22l-.488-1.912c-.8-3.142-2.582-6.002-5.151-8.269C11.034 25.668 9 21.192 9 16.517c0-4.423 1.777-8.584 5.003-11.719A16.876 16.876 0 0 1 26 .001c4.463.042 8.652 1.778 11.796 4.89Zm-3.527 21.068c2.773-2.386 4.364-5.827 4.364-9.441 0-6.856-5.685-12.487-12.672-12.552a12.827 12.827 0 0 0-9.115 3.65c-2.454 2.384-3.805 5.545-3.805 8.902 0 3.553 1.546 6.955 4.241 9.334 2.873 2.535 4.95 5.685 6.057 9.164h.477V22.33h-4.714v-3.963h13.47v3.963h-4.715v12.685h.475c1.115-3.548 3.152-6.662 5.937-9.057ZM20.885 45.134h9.904v4.103h-9.904v-4.103Z"
  })));
};

export default SvgLightingbulb;